import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
// import CreateServiceModal from "./components/createServiceModal";
import CreateVendorModal from "./createVendorModal";
// import CreateFormModal from "./components/createFormModal";
import { getVendorData } from "../../../store/slices/vendorListMappingSlice";
import FeatherIcon from "feather-icons-react";
import SubServiceDetails from "../SubServices/SubserviceDetails";
import { useDebounce } from "../../../Hooks/useDebounce";
const ManageVendors = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [totalCount, setCount] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isCreateSubServiceModalOpen, setIsCreateSubServiceModalOpen] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearch = useDebounce(searchQuery, 300);
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterSearch = useDebounce(columnFilters, 300);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const vendors = useSelector((state) => state.vendorListMappingSlice.vendorData);  
  const [selectedForm, setSelectedForm] = useState({});
  const [selectedSubService, setSelectedSubService] = useState(null);
  const client = useSelector((state) => state.clients?.selectedClient?.value);

  useEffect(() => {
    getVendorDataFunc({});
  }, []); 

  useEffect(() => {
    if (Array.isArray(vendors)) {
      setData(vendors);
      setCount(vendors.length);
    }
  }, [vendors]);

  const fetchData = async (payload) => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const sortField = sorting.length > 0 ? sorting[0].id : "";
        const sortOrder = sorting.length > 0 ? (sorting[0].desc ? "desc" : "asc") : "";
        // vendor_list is a shared table across all tenants (no tenant
        // scoping here previously) - scope to the active tenant so this
        // list doesn't mix in other tenants' vendors.
        const mergedFilters = [
          ...(Array.isArray(payload?.filters) ? payload.filters : []),
          ...(client ? [{ id: "tenant_slug", value: client }] : []),
        ];
        const queryPayload = {
          limit: pageSize,
          offset: page * pageSize,
          sortBy: sortField,
          sortOrder: sortOrder,
          ...payload,
          filters: mergedFilters,
        };
        await dispatch(getVendorData(queryPayload));
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchData({ search: debouncedSearch, filters: columnFilterSearch });
  }, [dispatch, page, pageSize, debouncedSearch, columnFilterSearch, sorting, client]);

  const getVendorDataFunc = () => {
    fetchData({ search: debouncedSearch, filters: columnFilterSearch });
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "ID",
        header: "ID",
        size: 100,
      },
      {
        accessorKey: "vendor_name",
        header: "Vendor Name",
        size: 100,
      },
      {
        accessorKey: "vendor_slug",
        header: "Vendor Slug",
        size: 100,
      },
      {
        accessorKey: "tenant_slug",
        header: "Tenant Slug",
        size: 100,
      },
      // {
      //   accessorKey: "actions",
      //   header: "Actions",
      //   size: 150,
      //   Cell: ({ row }) => (
      //     <div>
      //       {" "}
      //       <FeatherIcon
      //         icon="edit"
      //         size={15}
      //         className="w-10 text-primary cursor-pointer"
      //         onClick={() => {
      //           ToggleForm(row);
      //         }}
      //       />
      //     </div>
      //   ),
      // },
      // {
      //   accessorKey: "upload",
      //   header: "Upload Image",
      //   size: 150,
      //   Cell: ({ row }) => (
      //     <FeatherIcon
      //       icon="upload"
      //       color="primary"
      //       onClick={() => {
      //         setSelectedSubService(row.original);
      //       }}
      //     >
      //       Upload
      //     </FeatherIcon>
      //   ),
      // },
    ],
    []
  );

  const handlePageChange = (event) => {
    const newState = typeof event === "function" ? event({ pageIndex: page, pageSize: pageSize }) : event;
    setPage(newState.pageIndex);
    setPageSize(newState.pageSize);
  };

  const handleOnChangeSearch = (value) => {
    setSearchQuery(value);
    setPage(0);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: { density: "compact" },
    renderTopToolbarCustomActions: ({ table }) => (
      <div className="d-flex">
        <div
          sx={{
            display: "flex",
            gap: "16px",
            padding: "8px",
            flexWrap: "wrap",
          }}
        >
          <button
            className="btn bg-primary"
            disabled={client === "ts"}
            onClick={() => setIsCreateSubServiceModalOpen(true)}
          >
            Create Vendor
          </button>
        </div>
      </div>
    ),
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    rowCount: totalCount || 0,
    onPaginationChange: handlePageChange,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    state: {
      pagination: { pageIndex: page, pageSize: pageSize },
      sorting,
      columnFilters,
      globalFilter: searchQuery,
    },
    globalFilter: searchQuery,
    onGlobalFilterChange: handleOnChangeSearch,
  });

  const toggle = useCallback(() => {
    setModalOpen(!isModalOpen);
  }, [isModalOpen]);

  const ToggleForm = (row) => {
    setSelectedSubService(row?.original);
    setSelectedForm(row?.original?.ServiceForms);
    setModalOpen(!isModalOpen);
    // }
  };

  return (
    <Fragment>
      {/* <CreateFormModal
        isOpen={isModalOpen}
        toggle={toggle}
        editForm={
          selectedForm?.formFields ? JSON.parse(selectedForm?.formFields) : []
        }
        formData={selectedForm}
        selectedSubService={selectedSubService}
      ></CreateFormModal> */}
      <CreateVendorModal
        isOpen={isCreateSubServiceModalOpen}
        toggle={() =>
          setIsCreateSubServiceModalOpen(!isCreateSubServiceModalOpen)
        }
        onSuccess={() => {
          setIsCreateSubServiceModalOpen(false);
          getVendorDataFunc({});
        }}
      ></CreateVendorModal>
      <Breadcrumbs
        mainTitle="Vendors"
        parent="Vendors"
        parentPath="manage-vendors"
        title="Vendors List"
      />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <MaterialReactTable table={table} />
            </Card>
          </Col>
        </Row>
        {/* {selectedSubService && (
          <Row>
            <Col sm="12">
              <SubServiceDetails
                subService={selectedSubService}
                onClose={() => setSelectedSubService(null)}
              />
            </Col>
          </Row>
        )} */}
      </Container>
    </Fragment>
  );
};

export default ManageVendors;
